export default "__VITE_ASSET__TKC5cfe1__"